import { FilterItem, GroupedFilterItems } from 'palette/Filters/types';

const getFirstLetter = (item: FilterItem) : string => item.name.charAt(0).toUpperCase();

export const groupFilterItems = (items: FilterItem[]) : GroupedFilterItems => {
    const itemsFirstLettersArray = items.map(getFirstLetter);
    const uniqueLettersArray = Array.from(new Set(itemsFirstLettersArray));

    return uniqueLettersArray.reduce((itemsObject: GroupedFilterItems, letter) => {
        itemsObject[letter] = items.filter(item => getFirstLetter(item) === letter);
        return itemsObject;
    }, {});
};
